<template>
    <div>
        <v-menu
            ref="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            class="menu"
            :max-height="menuMaxHeight"
            v-model="menuVisible"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field 
                    class="text-field" 
                    readonly 
                    v-on="on"
                    :outlined="outlined"
                    :dense="dense"
                    ref="textField"
                    append-icon="mdi-menu-down"
                    :value="getSelectedItemNames()"
                />
            </template>

            <TreeSelector
                :items="items"
                :item-key="itemKey"
                :item-text="itemText"
                :item-children="itemChildren"
                hoverable
                :dense="dense"
                class="menu-content"
                :selectable="true"
                :selectionType="selectionType"
                :selectionCheck="selectionCheck"
                :multiSelect="multiSelect"
                v-model="selected"
                expand-icon="mdi-chevron-down"
            >
            </TreeSelector>

        </v-menu>
    </div>
</template>

<script>

import TreeSelector from '../selector/TreeSelector.vue';

export default {
    name: 'Combo-Tree',
    props:{

        value : {
            type:Array,
            default:[],
        },
        items:{
            type:Array,
            default:[],
        },
        itemText:{
            type:String,
            default:'name',
        },
        itemKey:{
            type:String,
            default:'id',
        },
        itemChildren:{
            type:String,
            default:'children',
        },
        outlined:{
            type:Boolean,
            default:false,
        },
        dense:{
            type:Boolean,
            default:false,
        },
        menuMaxHeight:{
            type:String,
            default:'400',
        },
        multiSelect:{
            type:Boolean,
            default:false,
        },
        selectionType:{
            type:String,
            default:'independent',
        },
        selectionCheck:{
            type:Function,
            default:function(){return true;},
        }
    },
    model:{
        prop:'value',
        event:'inputChange',
    },
    components: {
        'TreeSelector':TreeSelector
    },
    data () {
        return {
            selected:[],
            selectedItemNames:'',
            menuVisible:false,
        }
    },
    
    methods:{

        selectChanged(){
            let me = this;
            me.$emit('inputChange',me.selected);
        },

        initSelectedValue(){
            this.selected = this.value;
        },

        getSelectedItemNames(){
            let me = this;
            let names = [];
            me.selected.forEach(function(key){
                let item = me.itemMap.get(key);
                if(item){
                    names.push(item[me.itemText]);
                }
            });
            return names.toString();
        },

        genItemMap(){
            let itemMap = new Map();
            let me = this;
            me.items.forEach(function(item){
                me.collectMapItems(itemMap,item);
            });
            return itemMap;
        },

        collectMapItems(itemMap,item){
            let me = this;
            itemMap.set(item[me.itemKey],item);
            if(item[this.itemChildren]){
                item[this.itemChildren].forEach(function(itemChild){
                    me.collectMapItems(itemMap,itemChild);
                });
            }
        },
        
    },
    mounted(){
    },
    created(){
    },
    computed:{
        itemMap(){
            return this.genItemMap();
        },
        
    },
    watch: {
        selected:function(newVal){
            console.log("comboTree watching selected");
            let newValClone = JSON.parse(JSON.stringify(newVal));
            let valueClone = JSON.parse(JSON.stringify(this.value));
            if(newValClone.sort().toString()==valueClone.sort().toString())
                return;
            console.log("comboTree select changed");    
            this.selectChanged();
        },
        //初始化设置值的时候，需要同步给子组件
        value:function(newVal){
            console.log("comboTree watching value");

            let newValClone = JSON.parse(JSON.stringify(newVal));
            let selectedClone = JSON.parse(JSON.stringify(this.selected));
            if(selectedClone.sort().toString()!=newValClone.sort().toString()){
                console.log("comboTree value changed");    
                this.initSelectedValue();
            }

            console.log(newVal.length+" "+this.multiSelect);  
            if(newVal.length>0 && !this.multiSelect)
                this.menuVisible = false;
        },
        //items:function(newVal){
        //    this.genItemMap();
        //}

    }
}
</script>
<style scoped>

    .menu{
        width:100%;
    }

    .text-field{
        width:100%;
    }

    .menu-content{
        background: white;
    }

</style>
